import type { OwnersAndContributorsResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetOwnersAndContributorsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOwnersAndContributorsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetOwnersAndContributorsArgs = {
  parentId: string;
};

export const useGetOwnersAndContributors = createQueryHook<
  UseGetOwnersAndContributorsArgs,
  OwnersAndContributorsResponseRow[],
  GetOwnersAndContributorsQuery
>({
  trpcQueryOptions: (trpc, { parentId }) =>
    trpc.frontend.node.getOwnersAndContributors.queryOptions({ id: parentId }),
  mapTrpcDataToGraphQL: (data) => ({ ancestor_contributor: data }),
  graphqlDocument: GetOwnersAndContributorsDocument,
  graphqlVariables: ({ parentId }) => ({ parentId }),
});
